module.exports = __webpack_public_path__ + "static/img/02.1105d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/app/02.png
// module id = CVVX
// module chunks = 0